import type { Plan } from '@court-sync/shared';
import {
  getCompactFeatureStringsForClubTier,
  getCompactPlanCardFeatures,
  getStripeFeatureStringsForTier,
  normalizeClubPlanTier,
  resolveSubscriptionTierForDisplay,
} from '@court-sync/shared';

export const COMPACT_FEATURE_PREVIEW_COUNT = 5;

export function getFullFeaturesForPlan(plan: Plan): string[] {
  const clubTier = normalizeClubPlanTier(plan.internalId ?? null);
  if (clubTier) {
    return getCompactFeatureStringsForClubTier(clubTier);
  }
  const tier = resolveSubscriptionTierForDisplay(plan.name, plan.internalId ?? null);
  return getStripeFeatureStringsForTier(tier);
}

export function getPreviewFeaturesForPlan(plan: Plan): string[] {
  return getCompactPlanCardFeatures({
    name: plan.name,
    internalId: plan.internalId ?? null,
  }).slice(0, COMPACT_FEATURE_PREVIEW_COUNT);
}
